export default __webpack_public_path__ + "static/media/lovelockdown-artworkinfo2.499dedef.png";